export default __webpack_public_path__ + "static/media/asetukset.3d9e3673.png";